import { render } from "./AccountHeader.vue?vue&type=template&id=149fa25c&scoped=true"
import script from "./AccountHeader.vue?vue&type=script&lang=js"
export * from "./AccountHeader.vue?vue&type=script&lang=js"

import "./AccountHeader.vue?vue&type=style&index=0&id=149fa25c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149fa25c"]])

export default __exports__